import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom'

import Select from 'react-select';
import moment from 'moment';

import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import { Pagination } from 'antd';

import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";

const statusTypeArray = ["Active", "Deactivated"]
const vehicleTypeArray = ["Van", "Truck", "Bike"]
const fuelTypeArray = ["Petrol", "Diesel", "Electric", "CNG"]

function VehicleInformation() {
    const [state, setstate] = useState(2);

    const [statusType, setStatusType] = useState({ label: "All", value: "All" });
    const [vehicleType, setVehicleType] = useState({ label: "All", value: "All" });
    const [fuelType, setFuelType] = useState({ label: "All", value: "All" });

    const { theme, dropdownStyleDark } = useTheme();

    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [vehicleInformationList, setVehicleInformationList] = useState([]);
    const [vehicleInformationListApiState, setVehicleInformationListApiState] = useState(false);
    const [selectedVehicleInfoId, setSelectedVehicleInfoId] = useState(null)

    const [modalShow, setModalShow] = useState(false);
    const [editModalVehicleDetails, setEditModalVehicleDetails] = useState(false);
    const [vehicleInfo, setVehicleInfo] = useState({ vehicleType: null, vehicleNumber: null, vehicleFuelType: null, vehicleModel: null, manufactureYear: null });
    const [submitButton, setSubmitButton] = useState(false);

    const [searchValue, setSearchValue] = useState('');
    const [totalListLength, setTotalListLength] = useState(0);
    const [current_page, setCurrent_page] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [selectedYear, setSelectedYear] = useState(null)
    const [yearSelectionPopup, setYearSelectionPopup] = useState(false)
    const [yearRangeStart, setYearRangeStart] = useState(new Date().getFullYear())

    const apiController = useRef(new AbortController())

    var page_name = "vehicle-information";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                    // setStartDate(moment().utcOffset(timezone).subtract(6, "days").format("YYYY-MM-DD"));
                    // setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
                }
                else {
                    // setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                    // setEndDate(moment.utc().format("YYYY-MM-DD"));
                }
            }
            else {
                // setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                // setEndDate(moment.utc().format("YYYY-MM-DD"));
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function changeVehicleStatus(id, status) {
        setVehicleInformationListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/update-vehicle-information-status`, { method: 'POST', body: JSON.stringify({ "email": user.email, "vehicle_information_id": id, "add_status": status, "page_name": page_name, "flag": "collection_list", "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation !== "success") throw "get vehicle information status list api error"

        await getAllVehicleInformation(current_page, pageSize, searchValue, statusType.value, vehicleType.value, fuelType.value)

        setVehicleInformationListApiState(false)
    }

    async function getAllVehicleInformation(page_number, size, search_val, st, vt, ft) {
        try {
            if (vehicleInformationListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setVehicleInformationListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-all-vehicle-information`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "current_page": page_number - 1, "rows_per_page": size, "search_value": search_val, "status_type": st, "vehicle_type": vt, "fuel_type": ft, "page_name": page_name, "email": user.email, "flag": "collection_list", "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce coupon list api error"

            setVehicleInformationList(body.data.list)
            setTotalListLength(body.data.count)
            setVehicleInformationListApiState(false)
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getTimezoneInformation();
            let p2 = getAllVehicleInformation(current_page, pageSize, searchValue, statusType.value, vehicleType.value, fuelType.value);

            Promise.all([p1, p2])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state === 1) {
            getAllVehicleInformation(current_page, pageSize, searchValue, statusType.value, vehicleType.value, fuelType.value)
        }
    }, [current_page, pageSize, searchValue, statusType.value, vehicleType.value, fuelType.value])

    const vehicleInfoSubmit = () => {
        if (vehicleInfo.vehicleType === null) {
            swal("Warning!", "Vehicle Type cannot be empty", "warning");
            return
        }
        if (vehicleInfo.vehicleNumber === null) {
            swal("Warning!", "Vehicle Number cannot be empty", "warning");
            return
        }
        if (vehicleInfo.vehicleFuelType === null) {
            swal("Warning!", "Vehicle Fuel Type cannot be empty", "warning");
            return
        }
        if (vehicleInfo.vehicleModel === null) {
            swal("Warning!", "Vehicle Model cannot be empty", "warning");
            return
        }

        let object = { ...vehicleInfo, page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        // console.log(object)
        setSubmitButton(true)

        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-vehicle-information`, object, headers).then((res) => {
            setSubmitButton(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    getAllVehicleInformation(current_page, pageSize, searchValue, statusType.value, vehicleType.value, fuelType.value);
                    setModalShow(false)
                    setVehicleInfo({ vehicleType: null, vehicleNumber: null, vehicleFuelType: null, vehicleModel: null, manufactureYear: null })
                });
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const editVehicleInfoDetails = () => {
        if (vehicleInfo.vehicleType === null) {
            swal("Warning!", "Vehicle Type cannot be empty", "warning");
            return
        }
        if (vehicleInfo.vehicleNumber === null) {
            swal("Warning!", "Vehicle Number cannot be empty", "warning");
            return
        }
        if (vehicleInfo.vehicleFuelType === null) {
            swal("Warning!", "Vehicle Fuel Type cannot be empty", "warning");
            return
        }
        if (vehicleInfo.vehicleModel === null) {
            swal("Warning!", "Vehicle Model cannot be empty", "warning");
            return
        }

        let object = { ...vehicleInfo, "vehicle_information_id": selectedVehicleInfoId, page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        // console.log(object)
        setSubmitButton(true)

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-vehicle-information`, object, headers).then((res) => {
            setSubmitButton(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    getAllVehicleInformation(current_page, pageSize, searchValue, statusType.value, vehicleType.value, fuelType.value);
                    setModalShow(false)
                    setVehicleInfo({ vehicleType: null, vehicleNumber: null, vehicleFuelType: null, vehicleModel: null, manufactureYear: null })
                });
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Vehicle Informatioan</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <button className='btn btn-success' onClick={(e) => { setModalShow(true); setEditModalVehicleDetails(false); setVehicleInfo({ vehicleType: null, vehicleNumber: null, vehicleFuelType: null, vehicleModel: null, manufactureYear: null }) }}><i className="las la-plus"></i>Add New</button>
                    </div>
                </div>
                <div>
                    {state === 1 ?
                        <>
                            <div className="row gx-0 gap-5 m-2">
                                <div className='col-md-3'>
                                    <Select
                                        options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x, value: x } })]}
                                        onChange={(event) => { setStatusType(event); }}
                                        value={statusType}
                                        placeholder="Select Status Type..."
                                        styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        isLoading={vehicleInformationListApiState}
                                        isDisabled={vehicleInformationListApiState}
                                    />
                                </div>
                                <div className='col-md-3'>
                                    <Select
                                        options={[{ label: "All", value: "All" }, ...vehicleTypeArray.map(x => { return { label: x, value: x } })]}
                                        onChange={(event) => { setVehicleType(event); }}
                                        value={vehicleType}
                                        placeholder="Select Vehicle Type..."
                                        styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        isLoading={vehicleInformationListApiState}
                                        isDisabled={vehicleInformationListApiState}
                                    />
                                </div>
                                <div className='col-md-3'>
                                    <Select
                                        options={[{ label: "All", value: "All" }, ...fuelTypeArray.map(x => { return { label: x, value: x } })]}
                                        onChange={(event) => { setFuelType(event); }}
                                        value={fuelType}
                                        placeholder="Select Fuel Type..."
                                        styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        isLoading={vehicleInformationListApiState}
                                        isDisabled={vehicleInformationListApiState}
                                    />
                                </div>
                            </div>

                            <div className="card mb-5 mb-xl-8">
                                <div className="card-header border-0 pt-5">
                                    <h3 className="card-title align-items-start flex-column">
                                        <span className="card-label fw-bold fs-3 mb-1">Vehicle List</span>
                                        <span className="text-muted mt-1 fw-semibold fs-7">Over {vehicleInformationList.length} Vehicles</span>
                                    </h3>
                                    <div className="card-toolbar">
                                        <Pagination
                                            total={totalListLength}
                                            onChange={(page, pageSize) => {
                                                setCurrent_page(page);
                                                setPageSize(pageSize);
                                            }}
                                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                            defaultPageSize={pageSize}
                                            defaultCurrent={current_page}
                                            showSizeChanger={true}
                                        />
                                    </div>

                                </div>
                                <div className="card-body py-3">
                                    <div className="table-responsive" style={{
                                        minHeight: "200px"
                                    }}>
                                        <div className='m-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search Vehicles...' />
                                        </div>
                                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                            <thead>
                                                <tr className="fw-bold text-muted">
                                                    <th className="min-w-120px">Vehicle Id</th>
                                                    <th className="min-w-120px">Vehicle Type</th>
                                                    <th className="min-w-120px">Vehicle Number</th>
                                                    <th className="min-w-120px">vehicle Fuel Type</th>
                                                    <th className="min-w-120px">Vehicle Model</th>
                                                    <th className="min-w-120px">Manufacture Year</th>
                                                    <th className="min-w-120px">Status</th>
                                                    <th className="min-w-50px text-end">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    vehicleInformationListApiState ?
                                                        <tr>
                                                            <td colSpan={7} className="text-center pt-10">
                                                                <div className="spinner-border text-primary"></div>
                                                            </td>
                                                        </tr>
                                                        :
                                                        vehicleInformationList.length > 0 ?
                                                            vehicleInformationList.map((obj3, indx3) => {
                                                                return (
                                                                    <tr key={indx3}>
                                                                        <td>
                                                                            <a className="badge badge-secondary">{obj3.vehicle_id}</a>
                                                                        </td>
                                                                        <td>
                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.vehicle_type}</a>
                                                                        </td>
                                                                        <td>
                                                                            <a className="badge badge-light-primary">{obj3.vehicle_number}</a>
                                                                        </td>
                                                                        <td>
                                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.vehicle_fuel_type}</a>
                                                                        </td>
                                                                        <td>
                                                                            <a className="badge badge-light-info">{obj3.vehicle_model}</a>
                                                                        </td>
                                                                        <td>
                                                                            <a className="text-dark fw-bold d-block mb-1 fs-6">{obj3.manufacture_year ?? ""}</a>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                obj3.add_status === "Deactivated" ?
                                                                                    <span className="badge badge-light-danger">Deactivated</span>
                                                                                    :
                                                                                    obj3.add_status === "Active" ?
                                                                                        <span className="badge badge-light-success">Active</span>
                                                                                        :
                                                                                        <span className="badge badge-light-success">{obj3.add_status}</span>
                                                                            }
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <div className="dropdown">
                                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                    <i className="fas fa-bars px-0"></i>
                                                                                </button>
                                                                                {
                                                                                    write &&
                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                        <li className="py-1 cursor-pointer">
                                                                                            <span className="dropdown-item"
                                                                                                onClick={(e) => {
                                                                                                    setEditModalVehicleDetails(true);
                                                                                                    setSelectedVehicleInfoId(obj3.vehicle_information_id);
                                                                                                    setModalShow(true);
                                                                                                    setVehicleInfo({ vehicleType: obj3.vehicle_type, vehicleNumber: obj3.vehicle_number, vehicleFuelType: obj3.vehicle_fuel_type, vehicleModel: obj3.vehicle_model, manufactureYear: obj3.manufacture_year })
                                                                                                }}
                                                                                            >Edit Details
                                                                                            </span>
                                                                                        </li>
                                                                                        <li className="py-1 cursor-pointer">
                                                                                            <span className="dropdown-item" href="#"
                                                                                                onClick={() => {
                                                                                                    swal({
                                                                                                        title: "Alert!",
                                                                                                        text: `Do you want to change the status from ${obj3.add_status} to ${obj3.add_status === "Active" ? "Deactivated" : "Active"}?`,
                                                                                                        icon: "warning",
                                                                                                        buttons: true,
                                                                                                        dangerMode: true,
                                                                                                    })
                                                                                                        .then((val) => {
                                                                                                            if (val) {
                                                                                                                changeVehicleStatus(obj3.vehicle_information_id, obj3.add_status === "Active" ? "Deactivated" : "Active")
                                                                                                            }
                                                                                                        });
                                                                                                }}
                                                                                            >
                                                                                                Change status
                                                                                            </span>
                                                                                        </li>
                                                                                    </ul>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan={7} className="text-center">
                                                                    <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                </td>
                                                            </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        state === 2 ?
                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                            :
                            <PageError />
                    }
                </div>
            </div>
            <Modal show={modalShow} onHide={() => { setModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>{editModalVehicleDetails ? "Edit Vehicle Information" : "New Vehicle Informatioan"}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Vehicle Type</label>
                                <Select
                                    options={vehicleTypeArray.map(x => { return { label: x, value: x } })}
                                    onChange={(event) => { console.log(event); setVehicleInfo({ ...vehicleInfo, vehicleType: event.value }) }}
                                    value={vehicleInfo.vehicleType === null ? null : { label: vehicleInfo.vehicleType, value: vehicleInfo.vehicleType }}
                                    placeholder="Select Vehicle Type..."
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Vehicle Number</label>
                                <input className="form-control" value={vehicleInfo.vehicleNumber} onChange={(e) => { setVehicleInfo({ ...vehicleInfo, vehicleNumber: e.target.value }) }} placeholder="Enter Vehicle Number" />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Vehicle Fuel Type</label>
                                <Select
                                    options={fuelTypeArray.map(x => { return { label: x, value: x } })}
                                    onChange={(event) => { setVehicleInfo({ ...vehicleInfo, vehicleFuelType: event.value }) }}
                                    value={vehicleInfo.vehicleFuelType === null ? null : { label: vehicleInfo.vehicleFuelType, value: vehicleInfo.vehicleFuelType }}
                                    placeholder="Select Vehicle Fuel Type..."
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Vehicle Model</label>
                                <input className="form-control" value={vehicleInfo.vehicleModel} onChange={(e) => { setVehicleInfo({ ...vehicleInfo, vehicleModel: e.target.value }) }} placeholder="Enter Vehicle Model" />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Manufacture Year</label>
                                {/* <input type="date" className="form-control form-control-solid" value={vehicleInfo.manufactureYear} onChange={(e) => { setVehicleInfo({ ...vehicleInfo, manufactureYear: e.target.value }) }} placeholder="Enter Vehicle Manufacture Year" /> */}
                                <div style={{ position: "relative" }}>
                                    <input type="text" className="form-control" readOnly value={selectedYear === null ? "" : selectedYear} placeholder="YYYY" onClick={() => { setYearSelectionPopup(true) }} />
                                    <div className='' style={{ position: "absolute", width: "250px", backgroundColor: "white", padding: "1rem", boxShadow: "5px 5px 15px #888888", transition: "all 0.5s", visibility: yearSelectionPopup ? "visible" : "hidden", opacity: yearSelectionPopup ? "1" : "0" }}>
                                        <div className='d-flex justify-content-between'>
                                            <span>
                                                <span className='text-hover-primary cursor-pointer' onClick={() => { setYearRangeStart(yearRangeStart - 12) }}><i className="bi bi-arrow-left-short fs-1"></i></span>
                                                <span className='text-hover-primary cursor-pointer' onClick={() => { setYearRangeStart(yearRangeStart + 12) }}><i className="bi bi-arrow-right-short fs-1"></i></span>
                                            </span>
                                            <span className='fw-bold'>{yearRangeStart} - {yearRangeStart + 12}</span>
                                            <span className='text-hover-danger cursor-pointer' onClick={() => { setYearSelectionPopup(false) }}>✖</span>
                                        </div>
                                        <div className='d-flex flex-wrap align-items-center justify-content-around'>
                                            {
                                                Array.from({ length: 12 }, (_, i) => i + yearRangeStart).map((x, i) => {
                                                    return (
                                                        <div key={i} className={`p-3 text-hover-light cursor-pointer bg-hover-primary rounded ${selectedYear === x ? "bg-primary text-light" : ""}`} onClick={() => { setSelectedYear(x); setVehicleInfo({ ...vehicleInfo, manufactureYear: x }); setYearSelectionPopup(false); }}>{x}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {
                        write === 1 &&
                        <>
                            <button className="btn btn-danger rounded" disabled={submitButton} onClick={() => { setModalShow(false) }}>Close</button>
                            <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { editModalVehicleDetails ? editVehicleInfoDetails() : vehicleInfoSubmit() }}>
                                <span className="indicator-label">Save and Continue</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default VehicleInformation;